export const REPORT_FINANCIAL_POLICIES = Object.freeze({
    'report.platform.instrument-inventory': {
        sourceBook: 'INVESTMENT_BOOK',
        capabilityDomain: 'REFERENCE_DATA',
        generatorVersion: 'platform-instrument-inventory-v1',
        publicationState: 'VALIDATED',
        restatementState: 'ORIGINAL',
        methodologyVersion: 'platform-master-inventory-v1',
    },
    'report.portfolio.holdings': {
        sourceBook: 'INVESTMENT_BOOK',
        capabilityDomain: 'POSITION_MANAGEMENT',
        generatorVersion: 'holdings-snapshot-v1-latest-per-key',
        publicationState: 'VALIDATED',
        restatementState: 'ORIGINAL',
        positionBasis: 'SETTLED',
        valuationBasis: 'LATEST_AVAILABLE_MARKET_PRICE_AS_OF_DATE',
    },
    'report.client.holdings': {
        sourceBook: 'CLIENT_REPORTING_BOOK',
        capabilityDomain: 'CLIENT_REPORTING',
        generatorVersion: 'client-holdings-snapshot-v1',
        publicationState: 'VALIDATED',
        restatementState: 'ORIGINAL',
        positionBasis: 'SETTLED',
        valuationBasis: 'LATEST_AVAILABLE_MARKET_PRICE_AS_OF_DATE',
    },
    'report.portfolio.performance-nepal': {
        sourceBook: 'INVESTMENT_BOOK',
        capabilityDomain: 'PERFORMANCE',
        generatorVersion: 'portfolio-performance-v1-nepal-evidence',
        publicationState: 'VALIDATED',
        restatementState: 'ORIGINAL',
        positionBasis: 'SETTLED',
        valuationBasis: 'GOVERNED_VALUATION_FACT_AS_OF_DATE',
        methodologyVersion: 'return-on-cost-v1',
        ruleVersions: ['EFFECTIVE_TAX_RULE_PROVENANCE_FROM_DISPOSAL'],
    },
    'report.portfolio.realized-gain-loss': {
        sourceBook: 'INVESTMENT_BOOK',
        capabilityDomain: 'PERFORMANCE',
        generatorVersion: 'realized-gain-loss-facts-v1',
        publicationState: 'VALIDATED',
        restatementState: 'ORIGINAL',
        positionBasis: 'SETTLED',
        methodologyVersion: 'realized-gain-loss-facts-v1',
        ruleVersions: ['COST_BASIS_AND_DISPOSAL_FACT_AUTHORITY_V1'],
    },
    'report.portfolio.unrealized-gain-loss': {
        sourceBook: 'INVESTMENT_BOOK',
        capabilityDomain: 'PERFORMANCE',
        generatorVersion: 'latest-active-position-valuation-v1',
        publicationState: 'VALIDATED',
        restatementState: 'ORIGINAL',
        positionBasis: 'SETTLED',
        valuationBasis: 'GOVERNED_VALUATION_FACT_AS_OF_DATE',
        methodologyVersion: 'latest-active-position-valuation-v1',
        ruleVersions: [
            'LATEST_NONPOSITIVE_POSITION_CLOSES_POSITION_V1',
            'MISSING_VALUATION_MAKES_RESULT_PARTIAL_V1',
        ],
    },
    'report.tax.cgt-analytics': {
        sourceBook: 'TAX_BOOK',
        capabilityDomain: 'TAX',
        generatorVersion: 'cgt-facts-v1',
        publicationState: 'VALIDATED',
        restatementState: 'ORIGINAL',
        methodologyVersion: 'cgt-facts-v1',
        ruleVersions: ['EFFECTIVE_TAX_RULE_PROVENANCE_FROM_CGT_FACT'],
    },
    'report.portfolio.cash-position': {
        sourceBook: 'INVESTMENT_BOOK',
        capabilityDomain: 'PORTFOLIO_MANAGEMENT',
        generatorVersion: 'current-cash-position-v1',
        publicationState: 'VALIDATED',
        restatementState: 'ORIGINAL',
        cashBasis: 'PROJECTED',
        methodologyVersion: 'current-cash-position-v1',
        ruleVersions: ['CURRENT_STATE_ONLY_NO_HISTORICAL_RECONSTRUCTION_V1'],
    },
    'report.portfolio.cash-movement': {
        sourceBook: 'INVESTMENT_BOOK',
        capabilityDomain: 'PORTFOLIO_MANAGEMENT',
        generatorVersion: 'posted-cash-movement-v1',
        publicationState: 'VALIDATED',
        restatementState: 'ORIGINAL',
        cashBasis: 'SETTLED',
        methodologyVersion: 'posted-cash-movement-v1',
        ruleVersions: ['REVERSED_MOVEMENTS_EXCLUDED_FROM_FINANCIAL_TOTALS_V1'],
    },
    'report.portfolio.investment-income': {
        sourceBook: 'INVESTMENT_BOOK',
        capabilityDomain: 'PORTFOLIO_MANAGEMENT',
        generatorVersion: 'recognized-investment-income-v1',
        publicationState: 'VALIDATED',
        restatementState: 'ORIGINAL',
        cashBasis: 'SETTLED',
        methodologyVersion: 'recognized-investment-income-v1',
        ruleVersions: ['POSTED_CORPORATE_ACTION_RECEIPT_AND_FIXED_INCOME_INCOME_V1'],
    },
    'report.portfolio.fees-expenses': {
        sourceBook: 'ACCOUNTING_BOOK',
        capabilityDomain: 'ACCOUNTING',
        generatorVersion: 'approved-fee-records-v1',
        publicationState: 'VALIDATED',
        restatementState: 'ORIGINAL',
        cashBasis: 'ACCOUNTING',
        methodologyVersion: 'issued-fee-invoices-v1',
        ruleVersions: ['ISSUED_INVOICE_AUTHORITY_ONLY_V1'],
    },
    'report.portfolio.tax-lots-cost-basis': {
        sourceBook: 'INVESTMENT_BOOK',
        capabilityDomain: 'POSITION_MANAGEMENT',
        generatorVersion: 'current-lot-cost-basis-v1',
        publicationState: 'VALIDATED',
        restatementState: 'ORIGINAL',
        positionBasis: 'SETTLED',
        methodologyVersion: 'current-lot-cost-basis-v1',
        ruleVersions: ['CURRENT_LOT_STATE_NO_HISTORICAL_RECONSTRUCTION_V1'],
    },
    'report.portfolio.corporate-actions': {
        sourceBook: 'INVESTMENT_BOOK',
        capabilityDomain: 'CORPORATE_ACTIONS',
        generatorVersion: 'corporate-action-entitlement-projection-v1',
        publicationState: 'VALIDATED',
        restatementState: 'ORIGINAL',
        positionBasis: 'SETTLED',
        methodologyVersion: 'corporate-action-entitlement-projection-v1',
    },
    'report.accounting.general-ledger': {
        sourceBook: 'ACCOUNTING_BOOK',
        capabilityDomain: 'ACCOUNTING',
        generatorVersion: 'posted-general-ledger-v1',
        publicationState: 'VALIDATED',
        restatementState: 'ORIGINAL',
        cashBasis: 'ACCOUNTING',
        methodologyVersion: 'posted-general-ledger-v1',
        ruleVersions: ['POSTED_JOURNAL_LINES_ONLY_V1'],
    },
    'report.portfolio.valuation-quality': {
        sourceBook: 'INVESTMENT_BOOK',
        capabilityDomain: 'MARKET_DATA',
        generatorVersion: 'latest-valuation-quality-v1-active-positions',
        publicationState: 'VALIDATED',
        restatementState: 'ORIGINAL',
        positionBasis: 'SETTLED',
        valuationBasis: 'GOVERNED_VALUATION_FACT_AS_OF_DATE',
        methodologyVersion: 'latest-valuation-quality-v1-active-positions',
        ruleVersions: [
            'MISSING_VALUATION_ONLY_STALENESS_NOT_INFERRED_V1',
            'LATEST_NONPOSITIVE_POSITION_CLOSES_POSITION_V1',
        ],
    },
    'report.portfolio.allocation-exposure': {
        sourceBook: 'INVESTMENT_BOOK',
        capabilityDomain: 'PORTFOLIO_MANAGEMENT',
        generatorVersion: 'valuation-allocation-v1-active-positions',
        publicationState: 'VALIDATED',
        restatementState: 'ORIGINAL',
        positionBasis: 'SETTLED',
        valuationBasis: 'GOVERNED_VALUATION_FACT_AS_OF_DATE',
        methodologyVersion: 'valuation-allocation-v1-active-positions',
        ruleVersions: [
            'ALLOCATION_WEIGHTS_WITHIN_CURRENCY_V1',
            'CROSS_CURRENCY_WEIGHT_UNAVAILABLE_WITHOUT_GOVERNED_FX_V1',
            'LATEST_NONPOSITIVE_POSITION_CLOSES_POSITION_V1',
        ],
    },
    'report.management.portfolio-summary': {
        sourceBook: 'INVESTMENT_BOOK',
        capabilityDomain: 'PORTFOLIO_MANAGEMENT',
        generatorVersion: 'management-portfolio-summary-v1-active-positions',
        publicationState: 'VALIDATED',
        restatementState: 'ORIGINAL',
        positionBasis: 'SETTLED',
        valuationBasis: 'GOVERNED_VALUATION_FACT_AS_OF_DATE',
        methodologyVersion: 'management-portfolio-summary-v1-active-positions',
        ruleVersions: ['LATEST_NONPOSITIVE_POSITION_CLOSES_POSITION_V1'],
    },
    'report.client.portfolio.performance-nepal': {
        sourceBook: 'CLIENT_REPORTING_BOOK',
        capabilityDomain: 'CLIENT_REPORTING',
        generatorVersion: 'portfolio-performance-v1-nepal-evidence',
        publicationState: 'VALIDATED',
        restatementState: 'ORIGINAL',
        positionBasis: 'SETTLED',
        valuationBasis: 'GOVERNED_VALUATION_FACT_AS_OF_DATE',
        methodologyVersion: 'return-on-cost-v1',
        ruleVersions: ['EFFECTIVE_TAX_RULE_PROVENANCE_FROM_DISPOSAL'],
    },
    'report.portfolio.cdsc-custody-evidence': {
        sourceBook: 'INVESTMENT_BOOK',
        capabilityDomain: 'CUSTODY',
        generatorVersion: 'portfolio-custody-evidence-v1',
        publicationState: 'DRAFT',
        restatementState: 'ORIGINAL',
        positionBasis: 'SETTLED',
        methodologyVersion: 'identity-and-document-evidence-v1',
        ruleVersions: ['CDSC-IDENTITY-EVIDENCE-NOT-BALANCE-RECONCILIATION-V1'],
    },
    'report.client.cdsc-custody-evidence': {
        sourceBook: 'CLIENT_REPORTING_BOOK',
        capabilityDomain: 'CLIENT_REPORTING',
        generatorVersion: 'portfolio-custody-evidence-v1',
        publicationState: 'DRAFT',
        restatementState: 'ORIGINAL',
        positionBasis: 'SETTLED',
        methodologyVersion: 'identity-and-document-evidence-v1',
        ruleVersions: ['CDSC-IDENTITY-EVIDENCE-NOT-BALANCE-RECONCILIATION-V1'],
    },
    'report.accounting.trial-balance': {
        sourceBook: 'ACCOUNTING_BOOK',
        capabilityDomain: 'ACCOUNTING',
        generatorVersion: 'trial-balance-v1',
        publicationState: 'VALIDATED',
        restatementState: 'ORIGINAL',
        cashBasis: 'ACCOUNTING',
        methodologyVersion: 'double-entry-ledger-v1',
    },
    'report.accounting.financial-statements': {
        sourceBook: 'ACCOUNTING_BOOK',
        capabilityDomain: 'ACCOUNTING',
        generatorVersion: 'financial-statements-v1-posted-ledger-direct-cash-flow',
        publicationState: 'VALIDATED',
        restatementState: 'ORIGINAL',
        cashBasis: 'ACCOUNTING',
        methodologyVersion: 'posted-ledger-direct-cash-flow-v1',
        ruleVersions: ['EXPLICIT_CASH_EQUIVALENT_AND_COUNTERPARTY_CLASSIFICATION_V1'],
    },
    'report.reconciliation.breaks': {
        sourceBook: 'INVESTMENT_BOOK',
        capabilityDomain: 'RECONCILIATION',
        generatorVersion: 'reconciliation-breaks-v1',
        publicationState: 'VALIDATED',
        restatementState: 'ORIGINAL',
        methodologyVersion: 'reconciliation-policy-version-from-run',
    },
    'report.transaction.activity': {
        sourceBook: 'INVESTMENT_BOOK',
        capabilityDomain: 'POSITION_MANAGEMENT',
        generatorVersion: 'transaction-activity-v1-latest-valuation-per-position',
        publicationState: 'VALIDATED',
        restatementState: 'ORIGINAL',
        positionBasis: 'SETTLED',
        valuationBasis: 'LATEST_AVAILABLE_MARKET_PRICE_AS_OF_DATE',
        methodologyVersion: 'transaction-activity-v1',
    },
    'report.regulatory.sebon-monthly': {
        sourceBook: 'REGULATORY_BOOK',
        capabilityDomain: 'REGULATORY_REPORTING',
        generatorVersion: 'sebon-monthly-v1',
        publicationState: 'DRAFT',
        restatementState: 'ORIGINAL',
        ruleVersions: ['NEPAL-SEBON-REPORTING-BASELINE-V1'],
    },
    'report.regulatory.ird-cgt': {
        sourceBook: 'TAX_BOOK',
        capabilityDomain: 'TAX',
        generatorVersion: 'ird-cgt-v1',
        publicationState: 'DRAFT',
        restatementState: 'ORIGINAL',
        ruleVersions: ['NEPAL-TAX-SECURITIES-CGT-BASELINE-V1'],
    },
    'report.regulatory.nrb-quarterly': {
        sourceBook: 'REGULATORY_BOOK',
        capabilityDomain: 'REGULATORY_REPORTING',
        generatorVersion: 'nrb-quarterly-v1',
        publicationState: 'DRAFT',
        restatementState: 'ORIGINAL',
    },
    'report.regulatory.fiu-aml-ctf': {
        sourceBook: 'REGULATORY_BOOK',
        capabilityDomain: 'REGULATORY_REPORTING',
        generatorVersion: 'fiu-aml-ctf-v1',
        publicationState: 'DRAFT',
        restatementState: 'ORIGINAL',
    },
});
export const DASHBOARD_FINANCIAL_POLICIES = Object.freeze({
    'dashboard.organization.portfolio': {
        sourceBook: 'INVESTMENT_BOOK',
        capabilityDomain: 'PORTFOLIO_MANAGEMENT',
        generatorVersion: 'organization-portfolio-dashboard-v1',
        publicationState: 'VALIDATED',
        restatementState: 'ORIGINAL',
        positionBasis: 'SETTLED',
        valuationBasis: 'LATEST_AVAILABLE_MARKET_PRICE_AS_OF_DATE',
        methodologyVersion: 'organization-portfolio-dashboard-v1',
        ruleVersions: [
            'HOME_PRIMARY_KPI_AUTHORITY_V1',
            'HISTORICAL_ACTIVITY_CUTOFF_V1',
            'HISTORICAL_CASH_FAIL_CLOSED_V1',
            'GOVERNED_ALLOCATION_REUSE_V1',
        ],
    },
    'dashboard.client.portfolio': {
        sourceBook: 'CLIENT_REPORTING_BOOK',
        capabilityDomain: 'CLIENT_REPORTING',
        generatorVersion: 'client-portfolio-dashboard-v1',
        publicationState: 'VALIDATED',
        restatementState: 'ORIGINAL',
        positionBasis: 'SETTLED',
        valuationBasis: 'LATEST_AVAILABLE_MARKET_PRICE_AS_OF_DATE',
        methodologyVersion: 'client-portfolio-dashboard-v1',
    },
});
export function getReportFinancialPolicy(reportId) {
    return REPORT_FINANCIAL_POLICIES[reportId];
}
export function getDashboardFinancialPolicy(dashboardId) {
    return DASHBOARD_FINANCIAL_POLICIES[dashboardId];
}
export function validateFinancialSurfacePolicyRegistry() {
    const errors = [];
    for (const [surfaceId, policy] of Object.entries({
        ...REPORT_FINANCIAL_POLICIES,
        ...DASHBOARD_FINANCIAL_POLICIES,
    })) {
        if (!policy.generatorVersion.trim())
            errors.push(`${surfaceId}: generatorVersion is required`);
        if (policy.publicationState === 'PUBLISHED') {
            errors.push(`${surfaceId}: static policy must not pre-authorize PUBLISHED output`);
        }
    }
    return errors;
}
